angular.module('wbComponents').directive 'wbTableColumn',
[  ->
  restrict: 'A'
  require: '^wbTableSort'
  link: ($scope, $el, $attrs, table) ->
    $el.addClass('table-sortable')

    if $el[0].tagName is 'TH'
      $el.on('click', ->
        if (table.sort.orderBy is $attrs.wbTableColumn)
          reverse = !table.sort.reverse
        else
          reverse = false
        table.sortBy($attrs.wbTableColumn, reverse)
      )

    $scope.$watch((-> table.sort),
      ->
        if (table.sort.orderBy is $attrs.wbTableColumn)
          $el.addClass('table-sorted', true)
          $el.toggleClass('table-sorted-ascending', !table.sort.reverse)
        else
          $el.removeClass('table-sorted', table.sort.orderBy is $attrs.wbTableColumn)
          $el.removeClass('table-sorted-ascending', !table.sort.reverse)
      , true
    )
]
